import React from "react";
import { useAuth, useUser } from "@clerk/clerk-react";
import TokenContext from "./TokenContext";

export const TokenProvider = ({ children }) => {
  const { getToken } = useAuth();
  const { user } = useUser();

  // Async function to get the token
  const provideToken = async () => {
    return await getToken();
  };

  // Make sure user and primaryEmailAddress are not undefined
  const userEmail = user?.primaryEmailAddress?.emailAddress || "";

  return (
    <TokenContext.Provider
      value={{
        provideToken, // Async function to get token
        userEmail, // User's primary email address
        clerkUserObject: user, // Full Clerk user object
      }}
    >
      {children}
    </TokenContext.Provider>
  );
};
